<script setup>
import {computed, reactive, ref} from "vue";
import { Sunrise,Sunny,Sunset,Moon } from '@element-plus/icons-vue'
import {ElCol, ElRow,ElCard,ElButton,ElSlider,ElCheckboxGroup,ElCheckboxButton,ElCheckbox} from "element-plus";
import ComboFlightCard from "./ComboFlightCard.vue";
import moment from 'moment';


const props = defineProps({
    data:Object
});
const emit = defineEmits(['addflight']);
const data=props.data;

const flights=data.list;
const airlines=data.airlines;



const filters=ref({
    departuretimes:[],
    arrivaltimes:["6-11","12-17"],
    stops:[0, 1],
    stopsr:[0, 1],
    airlines:[],
    departuretimesr:["6-11","12-17"],
    arrivaltimesr:[],
})

flights.sort((a,b)=>(a.pricedetails.totalfare > b.pricedetails.totalfare) ? 1 : -1);

const filteredFlights = computed( () => {
    return filterByArrivalsr(filterByDeparturesr(filterByArrivals(filterByDepartures(filterByAirlines(filterByStopsr(filterByStops(flights)))))));
})

const filterByStops=(flightsl)=>{

    if(filters.value.stops.length>0){
        return flightsl.filter(flight => filters.value.stops.includes(flight.departure.stops));
    }
    else{
        return flightsl;
    }
}

const filterByStopsr=(flightsl)=>{
    if(filters.value.stopsr.length>0){
        return flightsl.filter(flight => filters.value.stopsr.includes(flight.return.stops));
    }
    else{
        return flightsl;
    }
}

const filterByAirlines=(flightsl)=>{

    if(filters.value.airlines.length>0){
        return flightsl.filter(flight => includesAny(flight.airlinesclist,filters.value.airlines)  );
    }
    else{
        return flightsl;
    }
}

const filterByDepartures=(flightsl)=>{

    if(filters.value.departuretimes.length>0){
        return flightsl.filter(flight => {
            var dpttime=moment(flight.departure.departure_datetime).format('HH');

            let status=false;

            filters.value.departuretimes.forEach((value, index) => {
                const arr=value.split("-");
                const fromt=parseInt(arr[0]);
                const tot=parseInt(arr[1]);

                if(dpttime>=fromt && dpttime<=tot){
                    status= true;
                }
            });


            return status;
        } );
    }
    else{
        return flightsl;
    }
}

const filterByArrivals=(flightsl)=>{

    if(filters.value.arrivaltimes.length>0){
        return flightsl.filter(flight => {
            var dpttime=moment(flight.departure.arrival_datetime).format('HH');

            let status=false;

            filters.value.arrivaltimes.forEach((value, index) => {
                const arr=value.split("-");
                const fromt=parseInt(arr[0]);
                const tot=parseInt(arr[1]);
                if(dpttime>=fromt && dpttime<=tot){
                    status= true;
                }
            });


            return status;
        } );
    }
    else{
        return flightsl;
    }
}

const filterByDeparturesr=(flightsl)=>{

    if(filters.value.departuretimesr.length>0){
        return flightsl.filter(flight => {
            var dpttime=moment(flight.return.departure_datetime).format('HH');

            let status=false;

            filters.value.departuretimesr.forEach((value, index) => {
                const arr=value.split("-");
                const fromt=parseInt(arr[0]);
                const tot=parseInt(arr[1]);

                if(dpttime>=fromt && dpttime<=tot){
                    status= true;
                }
            });


            return status;
        } );
    }
    else{
        return flightsl;
    }
}

const filterByArrivalsr=(flightsl)=>{

    if(filters.value.arrivaltimesr.length>0){
        return flightsl.filter(flight => {
            var dpttime=moment(flight.return.arrival_datetime).format('HH');

            let status=false;

            filters.value.arrivaltimesr.forEach((value, index) => {
                const arr=value.split("-");
                const fromt=parseInt(arr[0]);
                const tot=parseInt(arr[1]);
                if(dpttime>=fromt && dpttime<=tot){
                    status= true;
                }
            });


            return status;
        } );
    }
    else{
        return flightsl;
    }
}




const includesAny = (arr, values) => values.some(v => arr.includes(v));

const listlimit=ref(20);

const scrollPosition=ref(null);

const scrollContainer=ref(null);



const handleScroll=()=>{

    const container = scrollContainer.value;
    var currentScrollPosition = container.scrollTop



   if(scrollPosition.value!=null && currentScrollPosition < scrollPosition.value){
        if(scrollPosition.value<400){
            setistlimit();
        }
    }
    else{
        var newlimit=listlimit.value+5;
        if(newlimit>=filteredFlights.length){
            listlimit.value=filteredFlights.length;
        }
        else{
            listlimit.value=newlimit;
        }

    }
    scrollPosition.value = container.scrollTop;



}

const setistlimit=()=>{
    if(filteredFlights.length>20){
        listlimit.value=20;
    }
    else{
        listlimit.value=20;
    }
}


const addflight=(flight)=>{
    emit('addflight',flight)
}


</script>

<template>
    <el-row :gutter="10">

        <el-col class="flight-filters" :span="6">
            <el-card class="box-card">
                <template #header>
                    <div class="card-header">
                        <div>
                            <div class="font16 fw700">Filters</div>
                            <div class="font12  grey">showing {{flights.length}} flights</div>
                        </div>


                    </div>
                </template>
                <div class="data-list">

                    <el-row>
                        <el-col  :span="24">
                            <div class="font16 fw700">Onward  Stops</div>

                        </el-col>

                        <el-col class="stop-filter" :span="24">
                            <el-checkbox-group v-model="filters.stops" >
                                <el-checkbox-button  :label="0"  >
                                    Direct
                                </el-checkbox-button>
                                <el-checkbox-button  :label="1" >
                                    1 Stop
                                </el-checkbox-button>
                                <el-checkbox-button  :label="2" >
                                    1+ Stops
                                </el-checkbox-button>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col  :span="24">
                            <div class="font16 fw700">Return Stops</div>

                        </el-col>

                        <el-col class="stop-filter" :span="24">
                            <el-checkbox-group v-model="filters.stopsr" >
                                <el-checkbox-button  :label="0"  >
                                    Direct
                                </el-checkbox-button>
                                <el-checkbox-button  :label="1" >
                                    1 Stop
                                </el-checkbox-button>
                                <el-checkbox-button  :label="2" >
                                    1+ Stops
                                </el-checkbox-button>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-divider />
                    <el-row>
                        <el-col  :span="24">
                            <div class="font16 fw700">Onward Departure </div>

                        </el-col>

                        <el-col class="time-filter" :span="24">
                            <el-checkbox-group  v-model="filters.departuretimes" >
                                <el-checkbox-button  label="0-5"  >
                                    <el-icon><Sunrise /></el-icon>
                                    Before 6AM
                                </el-checkbox-button>
                                <el-checkbox-button  label="6-11" ><el-icon><Sunny /></el-icon>6AM - 12PM</el-checkbox-button>
                                <el-checkbox-button  label="12-17" ><el-icon><Sunset /></el-icon>12PM - 6PM</el-checkbox-button>
                                <el-checkbox-button  label="18-23" ><el-icon><Moon /></el-icon>After 6PM</el-checkbox-button>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col  :span="24">
                            <div class="font16 fw700">Onward Arrival </div>

                        </el-col>

                        <el-col class="time-filter" :span="24">
                            <el-checkbox-group v-model="filters.arrivaltimes" >
                                <el-checkbox-button  label="0-5"  >
                                    <el-icon><Sunrise /></el-icon>
                                    Before 6AM
                                </el-checkbox-button>
                                <el-checkbox-button  label="6-11" ><el-icon><Sunny /></el-icon>6AM - 12PM</el-checkbox-button>
                                <el-checkbox-button  label="12-17" ><el-icon><Sunset /></el-icon>12PM - 6PM</el-checkbox-button>
                                <el-checkbox-button  label="18-23" ><el-icon><Moon /></el-icon>After 6PM</el-checkbox-button>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-divider />
                    <el-row>
                        <el-col  :span="24">
                            <div class="font16 fw700">Return Departure </div>

                        </el-col>

                        <el-col class="time-filter" :span="24">
                            <el-checkbox-group  v-model="filters.departuretimesr" >
                                <el-checkbox-button  label="0-5"  >
                                    <el-icon><Sunrise /></el-icon>
                                    Before 6AM
                                </el-checkbox-button>
                                <el-checkbox-button  label="6-11" ><el-icon><Sunny /></el-icon>6AM - 12PM</el-checkbox-button>
                                <el-checkbox-button  label="12-17" ><el-icon><Sunset /></el-icon>12PM - 6PM</el-checkbox-button>
                                <el-checkbox-button  label="18-23" ><el-icon><Moon /></el-icon>After 6PM</el-checkbox-button>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col  :span="24">
                            <div class="font16 fw700">Return Arrival </div>

                        </el-col>

                        <el-col class="time-filter" :span="24">
                            <el-checkbox-group v-model="filters.arrivaltimesr" >
                                <el-checkbox-button  label="0-5"  >
                                    <el-icon><Sunrise /></el-icon>
                                    Before 6AM
                                </el-checkbox-button>
                                <el-checkbox-button  label="6-11" ><el-icon><Sunny /></el-icon>6AM - 12PM</el-checkbox-button>
                                <el-checkbox-button  label="12-17" ><el-icon><Sunset /></el-icon>12PM - 6PM</el-checkbox-button>
                                <el-checkbox-button  label="18-23" ><el-icon><Moon /></el-icon>After 6PM</el-checkbox-button>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-divider />

                    <el-row class="airlinefilters">
                        <el-col  :span="24">
                            <div class="font16 fw700">Airlines</div>
                        </el-col>

                        <el-col :span="24">
                            <el-scrollbar height="400px">
                                <el-checkbox-group v-model="filters.airlines" >
                                    <el-checkbox v-for="airline in airlines"  :label="airline.code">{{airline.name}}</el-checkbox>

                                </el-checkbox-group>
                            </el-scrollbar>

                        </el-col>
                    </el-row>
                </div>

            </el-card>
        </el-col>
        <el-col  :span="18">

            <combo-flight-card v-for="(flight,index) in filteredFlights" :index="index" :flight="flight" :key="flight.id" @addflight="addflight"></combo-flight-card>

        </el-col>
    </el-row>
</template>

<style scoped>

</style>
